const network = require("../network");
const maps = require("../maps");

class UtfGridOverlay {
    /**
     * UtfGridOverlay used to detect clickable areas of image tiles.
     * @param {String} url url of the grid server
     * @param {Object} [options] grid options
     * @constructor
     * @private
     * @memberOf woosmap.layers
     * @since 1.1.0
     */
    constructor(url, options) {
        // super();
        options = options || {};

        this.options = {
            subdomains: options.subdomains || "abc",
            minZoom: options.minZoom || 0,
            maxZoom: options.maxZoom || 24,
            tileSize: options.tileSize || 256,
            resolution: options.resolution || 4,
            useJsonP: options.useJsonP || false,
            pointerCursor: options.pointerCursor || true,
        };

        //The thing the mouse is currently on
        this._mouseOn = null;
        this._url = url;
        this._cache = {};

        // store added google maps Listeners to avoid _map.clearListeners calls.
        this._listeners = [];
        this._storeEventManager = options.storeEventManager;
        this.handlers = [];
    }

    getMap() {
        return this._map;
    }

    setMap(map) {
        if (this._map) {
            this.onRemove();
        }

        this._map = map;

        if (this._map) {
            this.onAdd();
        }
    }

    on(event, handler, target) {
        const handle = maps.events.addListener(target ? target : this._map, event, handler);
        this.handlers.push(handle);
    }

    off() {
        while (this.handlers.length) {
            maps.events.removeListener(this.handlers.pop());
        }
    }

    onAdd() {
        this._listeners.push(maps.events.addListener(this._map, "mousemove", this._move.bind(this)));
        this._listeners.push(maps.events.addListener(this._map, "idle", this._update.bind(this)));
        this._listeners.push(maps.events.addListener(this._map, "click", this._click.bind(this)));
        this._update();
    }

    onRemove() {
        let listener;
        while ((listener = this._listeners.pop())) {
            listener.remove();
            // maps.events.removeListener(this._map, listener);
        }
        this._hide_pointer();
    }

    _click(e) {
        const eventObject = this._objectForEvent(e);

        if (eventObject.data !== null) {
            this._storeEventManager.triggerWithSource(this, "click", eventObject.data.store_id);
        }
    }

    _show_pointer() {
        if (this.options.pointerCursor) {
            maps.utils.setDraggableCursor(this._map, "pointer");
        }
    }

    _hide_pointer() {
        if (this.options.pointerCursor) {
            maps.utils.setDraggableCursor(this._map, null);
        }
    }

    _move(e) {
        const on = this._objectForEvent(e);
        if (on.data !== this._mouseOn) {
            if (this._mouseOn) {
                this._storeEventManager.triggerWithSource(this, "mouseout", this._mouseOn.store_id);

                this._hide_pointer();
            }
            if (on.data) {
                // Should really be setting/triggering events on 'on'
                // but google events aren't that smart and so using 'this'
                // and binding 'on' to that event

                this._storeEventManager.triggerWithSource(this, "mouseover", on.data.store_id);
                this._show_pointer();
            }
            this._mouseOn = on.data;
        }
    }

    _objectForEvent(e) {
        const map = this._map;
        const tileSize = this.options.tileSize;
        const resolution = this.options.resolution;

        const point = e.latLng || e.point;

        const pixelPoint = maps.coordinates.getPixelCoordinates(map, point);
        const tileCoordinate = maps.coordinates.getTileCoordinates(map, point);

        // Get x/y of tile for key
        const tileX = tileCoordinate.x;
        const tileY = tileCoordinate.y;

        // Get x/y of grid
        const gridX = Math.floor((pixelPoint.x - tileX * tileSize) / resolution);
        const gridY = Math.floor((pixelPoint.y - tileY * tileSize) / resolution);

        const cacheLookupKey = `${map.getZoom()}_${tileX}_${tileY}`;

        const gridTile = this._cache[cacheLookupKey];

        if (!gridTile || !gridTile.grid) {
            return { latLng: e.latLng, data: null };
        }

        const idx = this._utfDecode(gridTile.grid[gridY].charCodeAt(gridX));
        const key = gridTile.keys[idx];
        let result = gridTile.data[key];

        if (!gridTile.data.hasOwnProperty(key)) {
            result = null;
        }

        return { latLng: e.latLng, pixelPoint: pixelPoint, data: result };
    }

    _update() {
        return;
        const zoom = Math.floor(this._map.getZoom());

        if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
            return;
        }

        const mapBounds = this._map.getBounds();

        if (mapBounds) {
            const mB_NE = mapBounds.getNorthEast();
            const mB_SW = mapBounds.getSouthWest();

            const neTilePoint = maps.coordinates.getTileCoordinates(this._map, mB_NE);
            const swTilePoint = maps.coordinates.getTileCoordinates(this._map, mB_SW);

            const width = Math.abs(neTilePoint.x - swTilePoint.x);
            const height = Math.abs(neTilePoint.y - swTilePoint.y);

            const x = swTilePoint.x;
            const y = swTilePoint.y;

            for (let dx = 0; dx <= width; dx++) {
                for (let dy = 0; dy <= height; dy++) {
                    const tx = x + dx;
                    const ty = y - dy;

                    const key = `${zoom}_${tx}_${ty}`;
                    if (!this._cache.hasOwnProperty(key)) {
                        this._cache[key] = null;
                        this._loadTile(zoom, tx, ty);
                    }
                }
            }
        }
    }

    _loadTile(zoom, x, y) {
        const tileUrl = this._getTileUrl(zoom, x, y);
        console.log(tileUrl);
        network
            .fetch(tileUrl)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                this._cache_tile_data(zoom, x, y, data);
            });
    }

    _getTileUrl(zoom, x, y) {
        const fzoom = Math.floor(zoom);
        return this._url
            .replace(/\$Z/g, fzoom)
            .replace(/\$X/g, this._normalizeCoordinate(x, fzoom))
            .replace(/\$Y/g, this._normalizeCoordinate(y, fzoom))
            .replace("png", "grid.json");
    }

    _cache_tile_data(zoom, x, y, data) {
        const key = `${zoom}_${x}_${y}`;
        this._cache[key] = data;
    }

    _utfDecode(c) {
        if (c >= 93) {
            c--;
        }
        if (c >= 35) {
            c--;
        }
        return c - 32;
    }

    _normalizeCoordinate(coord, zoom) {
        // tiles are on a 4^zoom tile grid
        const maxTiles = Math.sqrt(4 ** zoom);

        if (zoom > 0) {
            while (coord > maxTiles || coord < 0) {
                if (coord > maxTiles) {
                    coord -= maxTiles;
                } else if (coord < 0) {
                    coord += maxTiles;
                }
            }
        }

        return coord;
    }
}

module.exports = UtfGridOverlay;
